import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { getFontColorStyle } from '../../helpers';
import { FontColorType } from '../../helpers';
import type { FontWeight, TextAlignment, TextSize } from './text-style-helpers';
import { getFontFamilyStyle, getFontSizeStyle, getFontWeightStyle, getTextAlignStyle } from './text-style-helpers';

export type TextStyleProps = {
  size: TextSize;
  color: FontColorType;
  textAlign?: TextAlignment;
  weight: FontWeight;
};

const textComponentStyle = ({ size, color, textAlign, weight }: TextStyleProps) => css`
  ${getFontFamilyStyle(theme)}
  ${getFontSizeStyle(size, theme)}
  ${getFontColorStyle(color, theme)}
  ${textAlign ? getTextAlignStyle(textAlign) : null}
  ${getFontWeightStyle(weight, theme)}
`;

export const TextStyles = {
  text: (props: TextStyleProps) => textComponentStyle(props),
};
